const style = {
  wrapper: {
    display: `none`,
    '@media (min-width: 992px)': {
      display: `block`
    }
  },
  mobileShow: {
    display: `block`
  },
  collapseButton: {
    background: `#fff`,
    color: `#333`,
    height: `40px`,
    width: `40px`,
    margin: `5px 0`,
    border: 0
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/DashboardNavigation/style/navbar.js